import {ChangeDetectionStrategy, Component, HostBinding} from '@angular/core';

@Component({
  selector: 'homey-paragraphs',
  imports: [],
  templateUrl: './paragraphs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ParagraphsComponent {
  @HostBinding('class') class = 'flex flex-col gap-4';
}
